import { useTranslate } from '../hooks/useTranslate'
import type { VIDEO_EXTENSIONS } from './constants'
import type { MediaComponentProps } from './MarkdownMedia'

const VideoMimeTypes = {
  '.mp4': 'video/mp4',
} satisfies Record<(typeof VIDEO_EXTENSIONS)[number], string> as Record<
  string,
  string
>

export const MarkdownVideo = ({ src, alt }: MediaComponentProps) => {
  const translate = useTranslate()

  if (!src) {
    return null
  }

  const mimeType = VideoMimeTypes[`.${src.split('.').pop()}`]

  return (
    <video controls className="max-w-full h-auto rounded-lg shadow-md">
      <source src={src} type={mimeType} />
      {alt && <track kind="captions" src="no-captions" label={alt} />}
      {translate('markdownViewer.video.unsupported')}
    </video>
  )
}
